<script setup lang="ts">
import dayjs from '@/utils/dayjs'
import { getUa } from '@/utils/ua'
import Provider from './ui/provider/index.vue'
import 'dayjs/locale/en'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/zh-tw'

const route = useRoute()

const appSettingsStore = useAppSettingsStore()

const { locale } = useI18n()
const { generateI18nTitle } = useAppMenu()

const isPublicRoute = computed(() => route.meta.public === true)

// 设置网页 title
watch([
  () => appSettingsStore.settings.app.dynamicTitle,
  () => appSettingsStore.title,
  () => appSettingsStore.customTitleList,
  () => appSettingsStore.lang,
  () => isPublicRoute.value,
  () => route.meta.title,
], () => {
  nextTick(() => {
    if (isPublicRoute.value) {
      document.title = typeof route.meta.title === 'string' ? route.meta.title : '农连医数智中台'
    }
    else if (appSettingsStore.settings.app.dynamicTitle && appSettingsStore.title) {
      const title = appSettingsStore.customTitleList.find(item => item.fullPath === route.fullPath)?.title || generateI18nTitle(appSettingsStore.title)
      document.title = `${title} - ${'农连医数智中台'}`
    }
    else {
      document.title = '农连医数智中台'
    }
  })
}, {
  immediate: true,
  deep: true,
})

onMounted(() => {
  appSettingsStore.setMode(document.documentElement.clientWidth)
  window.addEventListener('resize', () => {
    appSettingsStore.setMode(document.documentElement.clientWidth)
  })

  void getUa().then((ua) => {
    document.body.setAttribute('data-os', ua.getOS().name || '')
  })
})

watch(() => appSettingsStore.lang, () => {
  locale.value = appSettingsStore.lang
})

watch(() => appSettingsStore.lang, () => {
  switch (appSettingsStore.lang) {
    case 'zh-cn':
      dayjs.locale('zh-cn')
      break
    case 'zh-tw':
      dayjs.locale('zh-tw')
      break
    case 'en':
      dayjs.locale('en')
      break
  }
}, {
  immediate: true,
})
</script>

<template>
  <Provider>
    <RouterView v-slot="{ Component }">
      <AppNotSupportedMobile v-if="!isPublicRoute && !appSettingsStore.settings.app.mobile && appSettingsStore.mode === 'mobile'" />
      <Component :is="Component" v-else />
    </RouterView>
    <template v-if="!isPublicRoute">
      <AppBackToTop />
      <KLToast :theme="appSettingsStore.currentColorScheme" />
      <AppLoginAgain />
      <AppCheckUpdates />
      <AppSystemInfo />
    </template>
  </Provider>
</template>
